import { getRequest } from '@/api/api';
import { IResponseNFT } from '@/api/loans/model';
import { IWalletCryptoData } from '@/redux/wallet/model';
import { changeIpfsURlToHttps } from '@/utils/helper';
import { MORALIS_CHAIN, SIMPLEHASH_CHAIN } from 'constant';

import { INFTsByWallet, INFTsByWalletParams, IWalletCollectionParams, IWalletCollectionRes, IWalletDataParams, IWalletValuationRes } from './types/simpleHash';

// export const getSimpleHash = async <T, P = Record<string, any>>(url: string, params?: P & Record<string, any>): Promise<T> => {
//   const options = {
//     method: 'GET',
//     headers: { accept: 'application/json', 'X-API-KEY': process.env.NEXT_PUBLIC_SIMPLE_HASH },
//   };

//   let queryParams;

//   if (params) {
//     queryParams = buildParams(params);
//   }

//   try {
//     const res = await fetch(`https://api.simplehash.com/api/v0/nfts/${url}${queryParams ? `?${queryParams}` : ''}`, options);
//     const nftData = await res.json();

//     return nftData;
//   } catch (e) {
//     return e as T;
//   }
// };

export const getWalletTraitFloor = async (params: { wallet_address: string }): Promise<{ data: number }> => {
  const res = await getRequest('/simplehash/trait-floor', { params });
  return res;
};

export const getWalletCryptoData = async (params: { wallet_addresses: string }): Promise<IWalletCryptoData> => {
  const res = await getRequest('/simplehash/wallet-crypto', { params });
  return res;
};

export const getWalletValuation = async (params: IWalletDataParams): Promise<IWalletValuationRes> => {
  const res = await getRequest('/simplehash/wallet-valuation', { params });
  return res;
};

export const getWalletCollection = async (params: IWalletCollectionParams): Promise<IWalletCollectionRes> => {
  const res = await getRequest('/simplehash/wallet-collection', { params: { ...params, chains: SIMPLEHASH_CHAIN } });
  return res;
};

export const getWalletNFTs = async (params: INFTsByWalletParams): Promise<IResponseNFT> => {
  const res: IResponseNFT = await getRequest('/simplehash/wallet-nfts', { params: { ...params, chain: MORALIS_CHAIN } });

  res.result.forEach((nft) => {
    if (nft?.normalized_metadata?.image) {
      nft.normalized_metadata.image = changeIpfsURlToHttps(nft.normalized_metadata.image);
    }

    if (nft?.media?.original_media_url) {
      nft.media.original_media_url = changeIpfsURlToHttps(nft.media.original_media_url);
    }
  });

  return res;
};

export const getWalletAllNFTs = async (params: { wallet_addresses: string; cachedData?: boolean; dontIncludePrice?: boolean }): Promise<{ walletCollection: INFTsByWallet['result']; nftUsdBalance: number }> => {
  const res = await getRequest('/simplehash/wallet-allNfts', { params });
  return res;
};

export const getAvailableChains = async () => {
  const res = await getRequest('/simplehash/chains', {});
  return res;
};
